"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";
import ApiRequest from "@/shared/lib/client-sdk/api-request";

class DistributionReason extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "DistributionReason";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/distribution-reasons"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create distribution reasons.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/distribution-reasons/" +
      this.code
    );
  }

  getAdminPath() {
    console.error("Cannot go to a distribution reason.");
  }

  static fetchAllIncludingClientScoped(callback) {
    var requestUrl = this.getApiPathForSearch() + "?includeClientScoped=true";
    ApiRequest.send("GET", requestUrl, null, this).onComplete(
      function (response) {
        if (callback) {
          if (response.successful) {
            callback(response.result);
          } else {
            callback(false);
          }
        }
      }.bind(this)
    );
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultTitle() {
    return this.displayName;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default DistributionReason;
